var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l(((this.data)),function(item,index){return _c('div',{key:index,staticClass:"container py-4"},[_c('h1',{staticClass:"col-12 text-center my-4 text-blue"},[_vm._v(_vm._s(item.title))]),_c('div',{domProps:{"innerHTML":_vm._s(item.text)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }